"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyOffset = void 0;
const common_1 = require("@finley-technologies/common");
/**
 * Applies a date offset and non business day adjustment to a DateTime date and returns a Util.FullDateStr
 */
const applyOffset = ({ date, offset, }) => {
    switch (offset.dayUnit) {
        case 'calendarDay': {
            const datetimeWithOffset = date.plus({ days: offset.days });
            const dateStrWithOffset = common_1.date.datetimeToFullDateStr(datetimeWithOffset);
            if (common_1.date.isBusinessDay(datetimeWithOffset, common_1.date.USFederalHolidays) ||
                !offset.nonBusinessDayAdjustment) {
                // this means this date is a business day or nonBizDayAdjustment has not been specified
                return dateStrWithOffset;
            }
            switch (offset.nonBusinessDayAdjustment) {
                case 'after':
                    return common_1.date.addBusinessDays(dateStrWithOffset, 1);
                case 'before':
                    return common_1.date.addBusinessDays(dateStrWithOffset, 0); // is this expected? ask jen
                default:
                    return (0, common_1.finleyAssertUnreachable)(offset.nonBusinessDayAdjustment);
            }
        }
        case 'businessDay':
            // @jendevelops TODO: add holidays to abide by
            // NOTE: no need to deal with non business day adjustment in this case, since we have a business day offset
            return common_1.date.addBusinessDays(common_1.date.datetimeToFullDateStr(date), offset.days);
        default:
            return (0, common_1.finleyAssertUnreachable)(offset);
    }
};
exports.applyOffset = applyOffset;
//# sourceMappingURL=offset.js.map